import { Show } from "solid-js";
import { UnautharizedGraphic } from "~/components/Auth/graphic";
import { Buis } from "~/components/Buis";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "~/components/ui/dialog";
import { isAuthenticated } from "~/stores/auth";
import { useDocumentContext } from "../../../providers/context";

export function MoreInfo() {
	const { selectedMoreInfo, closeMoreInfo, selected, "protect-moreinfo": protectMoreInfo } = useDocumentContext();

	return (
		<Dialog
			open={!!selectedMoreInfo()}
			onOpenChange={closeMoreInfo}
		>
			<DialogContent class="rounded-lg">
				<DialogHeader>
					<DialogDescription>
						<Buis value={selected()?.breadcrumb} />
					</DialogDescription>
					<DialogTitle class="pr-8">{selectedMoreInfo()?.title}</DialogTitle>
				</DialogHeader>
				<Show
					when={protectMoreInfo ? isAuthenticated() : true}
					fallback={<UnautharizedGraphic />}
				>
					<div
						class="max-h-[600px] overflow-y-auto pr-4"
						innerHTML={selectedMoreInfo()?.content ?? ""}
					/>
				</Show>
			</DialogContent>
		</Dialog>
	);
}
